<div class="boost-ad-container my-4 mx-4" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
	<button
		mat-icon-button
		class="mat-icon-rtl-mirror"
		[ngClass]="{ 'c-btn-close': locale.lang === 'en', 'c-btn-close-rtl': locale.lang !== 'en' }"
		[disableRipple]="true"
		(click)="onClose()"
	>
		<img [src]="'assets/icons/close.svg' |  s3Image" alt="close dialog" />
		<button hidden cdkFocusInitial></button>
	</button>

	<div class="row mx-0 mt-32px" *ngIf="data.package === 'vip'">
		<div class="col-12 px-0 d-flex flex-column align-items-center">
			<img [src]="'assets/images/payment/boost-ad.png' | s3Image" alt="logo" />
			<p class="boost-para fw-500 fs-20px text-center my-4">{{ locale.translations['payment']['n585'] }}</p>
		</div>
	</div>

	<div class="row mx-0 mt-32px mb-4" *ngIf="data.package !== 'vip'">
		<div class="col-12 px-0 d-flex flex-column align-items-center">
			<img [src]="'assets/images/payment/missed-call.svg' | s3Image" alt="logo" class="img-responsive" [class.rtl]="locale.lang === 'ku' || locale.lang === 'ar'" />
			<p class="fw-500 my-2 fs-20px text-center">{{ locale.translations['ads']['ad']['n652'] }}</p>
			<span class="fs-14px fw-500 fg-purple">{{ locale.translations['ads']['ad']['n666'] }} {{ data?.title }}</span>
		</div>
	</div>

	<span *ngIf="data.package !== 'vip'" class="fs-14px fg-grey mb-2">{{ locale.translations['ads']['ad']['n653'] }}</span>

	<div class="row mx-0">
		<div class="col-12 px-0">
			<ul class="boost-li bg-lightest-grey mb-4">
				<li *ngIf="data.package === 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n590'] }}
				</li>
				<li *ngIf="data.package === 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n695'] }}
				</li>
				<li *ngIf="data.package === 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n696'] }}
				</li>
				<li *ngIf="data.package === 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n697'] }}
				</li>
				<li *ngIf="data.package === 'vip'">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n693'] }}
				</li>
				<li *ngIf="data.package !== 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['ads']['ad']['n654'] }}
				</li>
				<li *ngIf="data.package !== 'vip'" class="mb-2">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['ads']['ad']['n655'] }}
				</li>
				<li *ngIf="data.package !== 'vip'">
					<img [src]="checkMarkImg" class="me-2" [ngClass]="{ ' ms-2': locale.lang !== 'en' }" />
					{{ locale.translations['payment']['n590'] }}
				</li>
			</ul>
		</div>
	</div>

	<app-button
		class="rocket fw-400"
		(click)="onPayment()"
		[label]="
			data.package === 'vip'
				? locale.translations['payment']['n621'] + ' - ' + locale.translations['payment']['n223']
				: (locale.translations['payment']['n342'] | titlecase) + ' - ' + locale.translations['pricing']['n190']
		"
		customClass="w-100 h-100 fw-400"
		[svgIcon]="data.package === 'vip' ? 'rocket' : ''"
		[disableRipple]="true"
	></app-button>
</div>
